import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core'
import { ColumnControlButtonComponent } from '../column-control-button/column-control-button.component'

@Component({
    selector: 'app-column-control-input-inline',
    templateUrl: './column-control-input-inline.component.html',
    styleUrls: ['./column-control-input-inline.component.scss'],
    standalone: false
})
export class ColumnControlInputInlineComponent extends ColumnControlButtonComponent {
  public inputVisible = false
  public currentValue: string = null
  public oldValue: string = null

  public timer

  @Output() eventValue = new EventEmitter<any>()

  @ViewChild('inputValue') input: ElementRef

  public save() {
    this.hideInput()
    this.eventValue.emit({ type: 'invoiceNumber', value: this.currentValue })
  }

  public showInput(add?: boolean): void {
    this.oldValue = this.currentValue
    this.inputVisible = true
    if (add) {
      setTimeout(() => {
        this.input.nativeElement.focus()
      }, 0)
    }
  }

  public hideInput(reset?: boolean): void {
    if (reset) {
      this.currentValue = this.oldValue
    }
    this.inputVisible = false
  }

  public clearInput(): void {
    this.currentValue = null
    this.save()
  }
}
